import api from './'

export default {

    /**
     * Send a code by SMS to the user
     * @param data
     */
    send(data) {
        return api
            .post(`/otp/send`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Resend a code by SMS to the user
     * @param data
     */
    resend(data) {
        return api
            .post(`/otp/resend`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Send the code entered for validation
     * @param data
     */
    validate(data) {
        return api
            .post(`/otp/validate`, data)
            .then(response => {
                return response.data
            })
    },

}
